/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { init, browserTracingIntegration } from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { msalConfig } from './app/auth-config';
import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Returns the base URL for the web app.
 *
 * @export
 * @return {string} base URL.
 */
export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

/**
 * Returns the base URL for the API behind this web app.
 *
 * @export
 * @return {string} API base URL.
 */
export function getBaseApiUrl() {
  return `${getBaseUrl()}api`;
}

/**
 * Provider array, used for injection into Angular.
 * @type {*} provider array.
 */
const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'BASE_API_URL', useFactory: getBaseApiUrl, deps: [] }
];

if (environment.production) {
  init({
    dsn: 'https://4bc5d733ca60438da8a912deeffee5cb@o1210024.ingest.sentry.io/6345677',
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: ['localhost', 'https://dev.visioninsights.com.au', 'https://visioninsights.com.au'],
    tracesSampleRate: 1
  });

  enableProdMode();
}

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
